import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Input,
  Button,
  Typography,
  Modal,
  Tag,
  Tabs,
  Pagination,
} from "antd";
import Highlighter from "react-highlight-words";
// import {
//   StudentHistoreyTableData,re
//   ChangeTestSearchText,
//   ChangeTestDetailsModalState,
//   ProceedtoTest,
//   fetchTestdata,
// } from "../../../actions/traineeAction";
import {
  changeStudentHistoryTestTableLoadingStatus,
  proceedingToTest,
  changeTestSearchText,
  changeTestDetailsModalState,
  setTraineeTestDetails,
} from "../../../reducers/trainee";
// import TestDetails from "../../trainer/testdetails/testdetails";
import {
  fetchStudentHistory,
  proceedToTest,
  fetchTestdata,
} from "../../../features/trianeeAsync";
import {
  givenLevels,
  givenSchools,
  givenYears,
  paper,
  terms,
} from "../../common/constants";
import "../alltest/allStudentTest.css";
import { truncateString } from "../examPortal/TestBoardHeaderTest";
import { useWindowDimensions } from "../examPortal/testBoard";
import { getRowsTable } from "../utils";
import { DownOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";

const StudentHistory = ({ title }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const { height, width } = useWindowDimensions();
  const trainee = useSelector((state) => state.trainee);

  const rows = getRowsTable(height);
  const componentRef = useRef(null);
  const [showData, setShowData] = useState({});
  const [filterQueries, setFilterQueries] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [takeTestIdData, setTakeTestIdData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = rows;

  const handleClick = useCallback((e) => {
    const btnId = e.target.dataset.id;
    setShowData({ [btnId]: true });
  }, []);

  const handleOpen = useCallback((key, obj) => {
    setTakeTestIdData({ key, obj });
    setIsModalOpen(true);
  }, []);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleFilterQueries = useCallback((e, name) => {
    const filterString = e.target.dataset.id;
    setShowData({});
    setSortedData([]);

    setFilterQueries((prev) => {
      const existingFilter = prev.find(
        (filter) => Object.keys(filter)[0] === name
      );
      if (existingFilter) {
        return prev.map((filter) =>
          Object.keys(filter)[0] === name ? { [name]: filterString } : filter
        );
      }
      return [...prev, { [name]: filterString }];
    });
  }, []);

  const handleSort = useCallback(
    (columnName) => {
      const sorted = [...(trainee?.studentHistory || [])];
      setFilterQueries([]);

      sorted.sort((a, b) => {
        const valueA = a[columnName] || "";
        const valueB = b[columnName] || "";
        return sortOrder === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      });

      setSortedData(sorted);
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    },
    [trainee?.studentHistory, sortOrder]
  );

  const handlePaginationChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  useEffect(() => {
    if (title) {
      dispatch(fetchStudentHistory({ title }));
    }
  }, [dispatch, title]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        e.target.innerText !== "Review Test" &&
        !givenLevels.find((item) => item.label === e.target.innerText) &&
        !givenYears.find((item) => item.label === e.target.innerText) &&
        !terms.find((item) => item.label === e.target.innerText) &&
        !givenSchools.find((item) => item.label === e.target.innerText) &&
        !paper.find((item) => item.label === e.target.innerText) &&
        componentRef.current &&
        !componentRef.current.contains(e.target)
      ) {
        setShowData({});
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div className="p-2">
        <Input
          ref={searchInputRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          className="mb-2 w-[188px] block"
        />
        <div className="flex gap-2">
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm)}
            icon={<SearchOutlined />}
            size="small"
            className="w-[90px]"
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            className="w-[90px]"
          >
            Reset
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined className={filtered ? "text-blue-500" : ""} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current?.select(), 100);
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[trainee.testSearchText]}
        autoEscape
        textToHighlight={text?.toString() || ""}
      />
    ),
  });

  const handleSearch = useCallback(
    (selectedKeys, confirm) => {
      confirm();
      dispatch(changeTestSearchText(selectedKeys[0] || ""));
    },
    [dispatch]
  );

  const handleReset = useCallback(
    (clearFilters) => {
      clearFilters();
      dispatch(changeTestSearchText(""));
    },
    [dispatch]
  );

const handleReview = (isCorrect) => {
  const testId = takeTestIdData?.key;
  const userId = takeTestIdData?.obj?.studentId;

  if (!testId || !userId) {
    console.error("Missing test ID or user ID for review navigation.");
    return;
  }

  dispatch(
    proceedToTest({
      testId,
      userId,
      callback: () =>
        dispatch(
          fetchTestdata({
            testid: testId,
            traineeid: userId,
          })
        ),
    })
  );

  navigate(
    `/trainee/taketest?testid=${testId}&traineeid=${userId}&isCorrect=${isCorrect}`
  );
};


  const data =
    sortedData.length > 0
      ? sortedData
      : trainee?.studentHistory?.filter((record) =>
          filterQueries.every((filter) =>
            Object.values(record).some((value) =>
              value
                ?.toString()
                .toLowerCase()
                .includes(Object.values(filter)[0].toLowerCase())
            )
          )
        ) || [];

  // const paginationConfig = {
  //   defaultCurrent: 1,
  //   pageSize,
  //   total: data.length,
  //   current: currentPage,
  //   onChange: handlePaginationChange,
  //   showSizeChanger: false,
  // };

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const visibleData = data.slice(startIndex, endIndex);

  const columns = [
    {
      title: "Name",
      dataIndex: "title",
      key: "title",
      width: "18%",
      render: (text) => (
        <div className="text-white capitalize">
          {truncateString(text, 15) || "N/A"}
        </div>
      ),
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      width: "10%",
      render: (text) => (
        <div className="text-white capitalize">{text || "N/A"}</div>
      ),
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      width: "10%",
      render: (text) => <div className="text-white">{text || "N/A"}</div>,
    },
    {
      title: "Term",
      dataIndex: "term",
      key: "term",
      width: "10%",
      render: (text) => <div className="text-white">{text || "N/A"}</div>,
    },
    {
      title: "School",
      dataIndex: "school",
      key: "school",
      width: "10%",
      render: (text) => <div className="text-white">{text || "N/A"}</div>,
    },
    {
      title: "Paper",
      dataIndex: "exam",
      key: "paper",
      width: "10%",
      render: (text) => <div className="text-white">{text || "N/A"}</div>,
    },
    {
      title: "Status",
      dataIndex: "markedStatus",
      key: "maskedStatus",
      width: "10%",
      render: (text) => text || "N/A",
    },
    {
      title: "Marks",
      key: "_id",
      dataIndex: "_id",
      render: (key, obj) => (
        <div className="text-white">
          {obj.markedStatus === "Pending"
            ? "N/A"
            : `${obj?.obtainedMarks}/${obj?.totalMarks}` || "N/A"}
        </div>
      ),
    },
    {
      title: "",
      key: "_id",
      dataIndex: "_id",
      render: (key, obj) => (
        <Button
          type="primary"
          className="rounded-full bg-blue-500 hover:bg-blue-600"
          onClick={() => handleOpen(key, obj)}
        >
          Review Test
        </Button>
      ),
    },
  ];

  const rowClassNameFn = (record, index) =>
    index % 2 === 0 ? "bg-gray-700" : "bg-gray-800";

  return (
    <>
      <div className="custom_trainee_table" style={{ marginTop: 5 }}>
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          {["Level", "Year", "Term", "School", "Paper"].map((filter) => (
            <div key={filter} className="relative" ref={componentRef}>
              <div
                data-id={filter}
                className="sortButton"
                onClick={handleClick}
                style={{ padding: "8px 20px" }}
              >
                <Typography.Text style={{ color: "white", fontWeight: 600 }}>
                  {filterQueries.find((item) => Object.keys(item)[0] === filter)
                    ? filterQueries.find(
                        (item) => Object.keys(item)[0] === filter
                      )[filter]
                    : filter}
                </Typography.Text>
                <div
                  className="icons"
                  onClick={() => handleSort(filter.toLowerCase())}
                >
                  <UpOutlined style={{ fontSize: "10px" }} />
                  <DownOutlined style={{ fontSize: "10px" }} />
                </div>
              </div>
              {showData[filter] && (
                <div className="absolute z-10 bg-gray-700 text-white rounded shadow-lg mt-1 p-2">
                  {(filter === "Level"
                    ? givenLevels
                    : filter === "Year"
                    ? givenYears
                    : filter === "Term"
                    ? terms
                    : filter === "School"
                    ? givenSchools
                    : paper
                  ).map((item) => (
                    <Typography.Text
                      key={item.value}
                      data-id={item.value}
                      onClick={(e) => handleFilterQueries(e, filter)}
                      className="block px-2 py-1 hover:bg-gray-600 cursor-pointer"
                    >
                      {item.label}
                    </Typography.Text>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: "55vh",
            height: "100%",
          }}
        >
          <Table
            columns={columns}
            dataSource={visibleData}
            loading={trainee.loading}
            rowKey="_id"
            rowClassName={rowClassNameFn}
            className="table"
            // components={{
            //   header: { 
            //     cell: (props) => (
            //       <th className="bg-gray-600 text-white font-bold" {...props} />
            //     ),
            //   },
            // }}
            pagination={{
              pageSize,
              total: data.length,
              current: currentPage,
              onChange: handlePaginationChange,
            }}
          />
        </div>
      </div>

      <Modal
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        centered
        width={350}
        style={{ borderRadius: "25px" }}
        closable={false}
      >
        <div style={{ width: "100%" }}>
          <Typography.Text className="modalTitle">
            Which review option do you wish to choose:
          </Typography.Text>
        </div>
        <div className="modalButtons">
          <Button className="modalButtonNo" onClick={() => handleReview(true)}>
            Full Review
          </Button>
          <Button className="modalButtonNo" onClick={() => handleReview(false)}>
            Correction Review
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default StudentHistory;
